import $ from 'jquery';
import Mmenu from 'mmenu-js';
import 'mmenu-js/dist/mmenu.css';

function initMobileMenu() {
  // Mobile menue (MMENU)
  // Prepare dynamic content for the mobile offcanvas (Mmenu) header buttons
  const $closeBtnMobile = $('a#burger-menu-toggle-mobile');
  const closeBtnHtml = $closeBtnMobile.length
    ? $closeBtnMobile[0].outerHTML.replace(/\s?id="[^"]*"/, 'id="mmenu-close"').replace(/\s?href="[^"]*"/, ' ')
    : '';
  const $pageLogo = $('#page-header .page-logo');
  const pageLogoHtml = $pageLogo.length ? $pageLogo[0].outerHTML : '';

  const topBarHtml = (
    `<div class="mmenu-topbar flex !justify-between pb-8 pt-5 px-4">` +
    `${pageLogoHtml}` +
    `${closeBtnHtml}` +
    `</div>`
  );

  const $langMenu = $('#page-header .menu-language');
  const langMenuHtml = $langMenu.length ? $langMenu[0].outerHTML : '';

  const bottomBarHtml = (
    `<div class="mmenu-bottom w-full px-3 py-3">` +
    `<div id="mmenu-lang" class="mb-3">${langMenuHtml}</div>` +
    `<div id="mmenu-meta" class="mt-3"></div>` +
    `</div>`
  );

  const mobileMmenu = new Mmenu('#mobile-navigation', {
    slidingSubmenus: false,
    language: 'de',
    theme: 'light-contrast',
    counters: {
      "add": false,
    },
    searchfield: {
      add: true,
      placeholder: 'Suche…',
      submit: true,
      search: false,
    },
    offCanvas: {
      position: 'bottom',
    },
    navbar: {
      title: '',
    },
    navbars: [
      {
        position: 'top',
        content: [topBarHtml],
      },
      {
        position: 'bottom',
        content: ['searchfield'],
      },
      {
        position: 'bottom',
        content: [bottomBarHtml],
      },
    ],
  }, {
    language: 'de',
    classNames: {
      selected: 'active',
    },
    offCanvas: {
      page: {
        selector: '#main-wrap',
      },
    },
    searchfield: {
      cancel: false,
      clear: false,
      submit: true,
      form: {
        action: '/suche',
        method: 'get',
      },
      input: {
        name: 'tx_indexedsearch_pi2[search][sword]',
      },
    },
  });
  const menueApi = mobileMmenu.API;
  // menueApi.close();

  $closeBtnMobile[0]
    .addEventListener(
      "click", () => {
        menueApi.open();
      }
    );

  // Fill placeholders in the navbars with existing page fragments
  try {
    const menuNode = mobileMmenu.node.menu;

    // Close button handler
    $(menuNode).on('click', '#mmenu-close', (e) => {
      e.preventDefault();
      menueApi.close();
    });

    // Add a magnifier icon to the searchfield on the right side
    const $searchfield = $(menuNode).find('.mm-searchfield');
    if ($searchfield.length) {
      $searchfield.addClass('relative');
      const $desktopSearchfield = $('#page-header .form-search button.btn-search[type="submit"]');
      // ensure input has right padding
      const $input = $searchfield.find('input.mm-searchfield__input');
      const $submitBtn = $searchfield.find('button.mm-searchfield__btn[type="submit"]');
      $submitBtn.html($desktopSearchfield[0].innerHTML);
    }

  } catch (e) {
    // fail silently – ensure the menu still works without extras
    console.warn('Mmenu enhancements failed', e);
  }
}

// auto-init on DOM ready
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => initMobileMenu());
} else {
  initMobileMenu();
}
